import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteReportTemplate } from "@services/reportEngine";

export const useDeleteReportTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation((id: string) => deleteReportTemplate(id), {
    onSuccess: () => queryClient.invalidateQueries(["reportTemplates"]),
  });
};
